
@if (_currentData._currentFormFields) {
  <dhs-form #formViewChild [action]="'ADD'" [fieldGroup]="_currentData._currentFormFields"
    [config]="_currentData.config" [data]="_currentData.currentData" (saveFinished)="sendToParent($event)"
    [formtype]="'popup'" (questionValueChanged)="questionValueChanged($event)" >
  </dhs-form>
}